// removed by extract-text-webpack-plugin
module.exports = {"number_wrapper":"number_wrapper__1q8hZ","time_style":"time_style__17BUG","seconds":"seconds__IgB6x","edittimer":"edittimer__1_-j3","button_wrapper":"button_wrapper__1rG9f","brews_style":"brews_style__2KmYE","timer_button":"timer_button__1Rrh5","play_icon":"play_icon__1elDf"};


//////////////////
// WEBPACK FOOTER
// ./components/timer/style.scss
// module id = XncA
// module chunks = 3